import React from 'react'
import styles from './PopOpenHours.scss'

function PopOpenHours(props) {
  const { openHoursText = [], openDay = 0, onClickCloseButton } = props

  return (
    <div className="popSlidein__wrapper">
      <style jsx>{styles}</style>
      <div className="popSlidein__content popSlidein__content--info">
        <div className="popSlidein__title">營業時間</div>
        <div className="popSlidein__line" />
        <div className="popSlidein__timetable">
          {openHoursText.map((t, i) => (
            <div key={i} className={`${(i + 1) % 7 === openDay ? '--active' : ''}`}>
              {t}
            </div>
          ))}
        </div>
      </div>
      <div className="btn-cancel" onClick={onClickCloseButton} />
    </div>
  )
}

export default PopOpenHours
